import api from './client';

export const getCheckouts = (params?: any) => api.get('/checkouts', { params });
export const createCheckout = (data: any) => api.post('/checkouts', data);
export const returnBook = (id: number) => api.put(`/checkouts/${id}/return`);
